export default "__VITE_ASSET__d7a3eae0__"